import { Component, input, linkedSignal, output } from '@angular/core';
import { IonInput } from '@ionic/angular/standalone';
import type { IonInputCustomEvent, InputInputEventDetail } from '@ionic/core/components';

@Component({
  selector: 'mbp-input-number',
  templateUrl: './mbp-input-number.component.html',
  styleUrl: './mbp-input-number.component.scss',
  imports: [IonInput]
})
export class MbpInputNumberComponent {
  value = input<string>('');
  min = input<number | undefined>(undefined);
  disabled = input<boolean>(false);
  invalid = input<boolean>(false);

  valueChange = output<string>();
  inputBlur = output<void>();

  protected internalValue = linkedSignal(() => this.value());

  protected handleInput(event: IonInputCustomEvent<InputInputEventDetail>): void {
    this.applyValue(event.detail.value ?? '');
  }

  protected handleArrow(event: Event, delta: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.step(delta);
  }

  protected step(delta: number): void {
    if (this.disabled()) {
      return;
    }
    const current = Number(this.internalValue());
    const next = (Number.isFinite(current) ? current : 0) + delta;
    const min = this.min();
    this.applyValue(String(min === undefined ? next : Math.max(min, next)));
  }

  private applyValue(nextValue: string): void {
    this.internalValue.set(nextValue);
    this.valueChange.emit(nextValue);
  }
}
